import React from "react";

import { TextField } from "@graffer-inc/console-design-kit";

import { Roles } from "../../../application/domain/rbac/rbac";
import { ServiceAccount } from "../../../application/domain/service-account/service-account";
import { GroupSelector } from "../../molecules/group-selector";
import { UserRolesSelector } from "../../molecules/user-role-selector";

type CommonUpsertFields = Pick<
  ServiceAccount,
  "description" | "roles" | "groupsRoles"
>;

type Props<T> = {
  input: T;
  onChange: (input: T) => void;
  tenantId: string;
  validationState: { [key in keyof CommonUpsertFields]?: string };
  shouldDisplayError: boolean;
};

export const ServiceAccountCommonUpsertForm = <T extends CommonUpsertFields>({
  input,
  onChange,
  tenantId,
  validationState,
  shouldDisplayError,
}: Props<T>): React.ReactNode => {
  return (
    <>
      <div className="columns">
        <div className="column">
          <TextField
            label="説明文"
            value={input.description}
            onChange={(e) => {
              onChange({
                ...input,
                description: e.target.value,
              });
            }}
            placeholder="説明文を入力してください"
            description="256文字以内で入力してください。"
            errorMessages={validationState.description}
            shouldDisplayError={shouldDisplayError}
          />
        </div>
      </div>

      <div className="columns">
        <div className="column">
          <UserRolesSelector
            label="ロール設定"
            required
            values={input.roles}
            onChange={(e) => {
              const newRoles = e.target.checked
                ? [...input.roles, e.target.value as Roles]
                : input.roles.filter((v: Roles) => v !== e.target.value);
              onChange({
                ...input,
                roles: newRoles,
                groupsRoles: newRoles.includes("Staff")
                  ? input.groupsRoles
                  : {},
              });
            }}
            errorMessages={validationState.roles}
            shouldDisplayError={shouldDisplayError}
          />
        </div>
      </div>
      {input.roles.length > 0 && (
        <div className="columns">
          <div className="column">
            {input.roles.includes("Staff") ? (
              <GroupSelector
                editingGroupRoles={input.groupsRoles}
                setGroupRoles={(groupsRoles) =>
                  onChange({
                    ...input,
                    groupsRoles,
                  })
                }
                validationError={
                  shouldDisplayError ? validationState.groupsRoles : undefined
                }
                orgId={tenantId}
                isServiceProvider={true}
              />
            ) : (
              <p className="control">
                特権管理者およびアカウント管理者はグループに所属しません。
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
